import { CompanyPurchasing } from '../modules/purchasing/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { PurchasingView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyPurchasingScreen({
  view,
  onView,
}: {
  view: PurchasingView;
  onView: ViewSetter<PurchasingView>;
}) {
  const { can, timeZone, company } = useCompanyScope();
  const units = company.businessUnits ?? [];
  const consolidated = units.length > 1 && (company.activeBusinessUnitId ?? null) === null;
  return (
    <GatedCompanyScreen allowed={can('purchasing.read')}>
      <CompanyPurchasing
        capabilities={{
          canManageSuppliers: can('purchasing.suppliers.manage'),
          canManageOfferings: can('purchasing.offerings.manage'),
          canManageOrders: !consolidated && can('purchasing.orders.manage'),
          canManageReceipts: !consolidated && can('purchasing.receipts.manage'),
        }}
        consolidated={consolidated}
        timeZone={timeZone}
        view={view}
        onView={onView}
      />
    </GatedCompanyScreen>
  );
}
